import { useState } from 'react';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { ICONS } from 'src/assets/library';
import { addUserSchema } from 'src/config/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ADD_USER, UPDATE_USER } from 'src/apiService/apiDeclaration';
import CustomTextField from 'src/components/formFields/textField';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import { showErrorTost, showSuccessTost } from 'src/constants';
import CustomSelectField from 'src/components/formFields/selectField';
import { roleArray, userStatusArray } from 'src/constants';
const AddUserForm = ({ onSuccess, data, isAdmin }) => {
  const [loading, setLoading] = useState(false);
  const defaultValues = {
    email: data?.email,
    role: isAdmin ? 'ADMIN' : 'EMPLOYEE',
    status: data?.status,
  };
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(addUserSchema),
    defaultValues,
  });

  const onSubmit = async (body) => {
    setLoading(true);
    try {
      let resp;
      if (data) {
        resp = await UPDATE_USER(data._id, body);
      } else {
        resp = await ADD_USER(body);
      }
      showSuccessTost(resp.message);
      onSuccess();
    } catch (error) {
      showErrorTost(error.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={12}>
          <CustomTextField
            placeholder={'name@domain.com'}
            type="email"
            icon={ICONS.email}
            controller={{
              name: 'email',
              control: control,
              errors: errors.email,
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <CustomSelectField
            label={'Role'}
            disabled={true}
            optionsArray={roleArray}
            controller={{
              name: 'role',
              control: control,
              errors: errors.role,
            }}
          />
        </Grid>
        {data && (
          <Grid item xs={12} md={12}>
            <CustomSelectField
              label={'Status'}
              optionsArray={userStatusArray}
              controller={{
                name: 'status',
                control: control,
                errors: errors.status,
              }}
            />
          </Grid>
        )}
        <Grid item xs={12} md={3}>
          <LoaderButton
            disabled={!isValid || !isDirty}
            loading={loading}
            buttonText={data ? 'Edit' : 'Add'}
            type="submit"
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default AddUserForm;
